/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PracticeHub/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import InviteAction from './InviteAction/index'
import People from './People/index'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2UserHomeSingle from 'DesignSystem/Svgs/Tysiav2UserHomeSingle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PracticeHub({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/PracticeHub"
  
}) {
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
 borderColor={dtColorsNeutral300}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
 paddingTop={dtSpaceLs}
 paddingBottom={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 borderBottomColor={dtColorsNeutral200}
 borderBottomWidth={1}
>
{childProps => (
<div
  data-testid="PracticeHub.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PracticeHub.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-1-1NDsbe': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal1}`}
>
<Tysiav2UserHomeSingle
  viewPath={`${viewPath}/Tysiav2UserHomeSingle`}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 text="Practice Hub"
/>
</div>
<InviteAction
  viewPath={`${viewPath}/InviteAction`}
/>
</div>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingBottom={dtSpaceLs}
 paddingTop={dtSpaceLs}
 paddingLeft={dtSpaceS}
 paddingRight={dtSpaceS}
 flexDirection="column"
 overflowX="visible"
 overflowY="visible"
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="People who have access"
/>
<People
{...childProps}
  viewPath={`${viewPath}/People`}
/>
</React.Fragment>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}